/**
 * Copyright 2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { AuditLogIdentityType } from "~/generated/graphql";
import { ListWithInputsItem } from "~/components/SidebarWithMultiSelect";

export const operationCheckboxes = [
  {
    value: "create",
    label: "Create",
  },
  {
    value: "update",
    label: "Update",
  },
  {
    value: "delete",
    label: "Delete",
  },
  {
    value: "execute",
    label: "Execute",
  },
];

export const targetCheckboxes = [
  {
    value: "resource",
    label: "Resource",
  },
  {
    value: "resource_group",
    label: "Resource Group",
  },
  {
    value: "plan",
    label: "Plan",
  },
  {
    value: "cloud_account",
    label: "Cloud Account",
  },
  {
    value: "notification_group",
    label: "Notification Group",
  },
  {
    value: "user",
    label: "User",
  },
  {
    value: "api_key",
    label: "API Key",
  },
  {
    value: "role",
    label: "Role",
  },
];

export const identityCheckboxes: ListWithInputsItem[] = [
  {
    value: AuditLogIdentityType.User,
    label: "User",
    allowMultipleInputs: false,
    addInputButtonText: "Add User",
    inputPlaceholderText: "johndoe@example.com",
  },
  {
    value: AuditLogIdentityType.ApiKey,
    label: "API Key",
    allowMultipleInputs: false,
    addInputButtonText: "Add API Key",
    inputPlaceholderText: "e.g., API Key ID",
  },
  {
    value: AuditLogIdentityType.System,
    label: "System",
    noInputs: true,
  },
];
